import React from 'react';
import Navbar from '../Navbars/Navbar2';
import {Button, Card} from 'antd';
import {permColors} from '../../utils/colors';
import {CheckCircleOutlined} from '@ant-design/icons';
import GoogleReviews from './GoogleReview';
import {ROUTES} from '../../utils/ROUTES';
import {useNavigate} from 'react-router-dom';

export default function InitialRoleSection({h1, pArray, image, imageAlt, h2, buttonText = 'Post a free Job Ad'}) {
	const navigate = useNavigate();
	const handleClick = () => {
		navigate(ROUTES.POST_JOB);
	};

	return (
		<div className="w-full bg-permhunt flex flex-col justify-center ">
			<Navbar darkMode={true} />

			<Card className="w-[1240px] max-w-full p-3 px-1 py-10 text-left bg-transparent border-none mx-auto" key="r">
				<div className="flex flex-col lg:flex-row justify-center items-center gap-12">
					<div className="left min-w-[300px] max-w-[550px]">
						<h1 className="mb-3 text-4xl font-medium " style={{lineHeight: '1.3', color: permColors.white}}>
							{h1}
						</h1>

						<div className="flex flex-col gap-2 my-2">
							{pArray.map((p: string, i: number) => (
								<p key={i} className={'flex gap-3 items-start max-w-full opacity-90 text-base font-light'} style={{color: permColors.white}}>
									<CheckCircleOutlined className="mt-1" />
									<span>{p}.</span>
								</p>
							))}
						</div>

						<Button
							type="primary"
							className="h-[40px] w-full max-w-[500px] bg-white/90 text-deepBlue hover:bg-backgroundGreyBlue/20 border-white/20 hover:text-white border-1 mt-3 mb-2 font-semibold"
							onClick={handleClick}>
							{buttonText}
						</Button>
						<p className="text-white/80 text-sm font-light italic">No credit card needed*</p>
						<GoogleReviews />
					</div>
					<img src={image} alt={imageAlt} className="rounded-lg object-cover w-[400px] mb-[-64px] lg:mb-[-101px]" />
				</div>
			</Card>
		</div>
	);
}
